<div class="d-flex justify-content-between pt-3 pb-3">
    <img class="logo" src="./assets/img/logo_astorget.jpg" alt="Astroget logo">
    <button class="btn btn-danger" (click)="resetForm();">Clear search</button>
</div>
<!-- Desktop View -->
<div *ngIf="driversDesktop">
    <div
        *ngIf="data | tableFilter : searchName:searchPhone:searchCarNumber:searchCarrier:searchOrderNumber:searchRequestNumber:searchStatus:searchPlantName:searchClientName:searchAddress:searchDeliveryStatus as filteredResult">
        <div *ngIf="isLoading" class="spinner d-flex justify-content-center align-items-center">
            <app-spinner></app-spinner>
        </div>
        <div
            class="drivers-list-wrap">
            <table *ngIf="!isLoading" class="table table-basic">
                <thead>
                    <tr>
                        <th scope="col">
                            <form #form="ngForm">
                                <div class="form-group">
                                    <label *ngIf="inputRequestNumber.pristine" for="requestNumber">Request ID</label>
                                    <input type="text" id="requestNumber" #inputRequestNumber="ngModel" [(ngModel)]="requestNumber" [ngModelOptions]="{standalone: true}" (keyup)="onGetSearchRequestNumber($event.target.value)" class="form-control">
                                </div>
                            </form>
                        </th>
                        <th scope="col">
                            <form #form="ngForm">
                                <div class="form-group">
                                    <label *ngIf="inputOrderNumber.pristine" for="orderNumber">Doc ID</label>
                                    <input type="text" id="orderNumber" #inputOrderNumber="ngModel" [(ngModel)]="orderNumber" [ngModelOptions]="{standalone: true}" (keyup)="onGetSearchOrderNumber($event.target.value)" class="form-control">
                                </div>
                            </form>
                        </th>
                        <th scope="col">
                            <form #form="ngForm">
                                <div class="form-group">
                                    <label *ngIf="inputPlantName.pristine" for="plantName">Plant</label>
                                    <select class="form-control" id="plantName" name="plantName" #inputPlantName="ngModel" [(ngModel)]="plantName" [ngModelOptions]="{standalone: true}" (change)="onGetSearchPlantName($event.target.value)">
                                        <option value="">All</option>
                                        <option value="Irpin">Plant&nbsp;Irpin</option>
                                        <option value="Obolon">Plant&nbsp;Obolon</option>
                                        <option value="Vidradnyi">Plant&nbsp;Vidradnyi</option>
                                        <option value="Darnytsa">Plant&nbsp;Darnytsa</option>
                                        <option value="Stolychnyi">Plant&nbsp;Stolychnyi</option>
                                    </select>
                                </div>
                            </form>
                        </th>
                        <th scope="col">
                            <form #form="ngForm">
                                <div class="form-group">
                                    <label *ngIf="inputClientName.pristine" for="clientName">Client</label>
                                    <input type="text" id="clientName" #inputClientName="ngModel" [(ngModel)]="clientName" [ngModelOptions]="{standalone: true}" (keyup)="onGetSearchClientName($event.target.value)" class="form-control">
                                </div>
                            </form>
                        </th>
                        <th scope="col">
                            <form #form="ngForm">
                                <div class="form-group">
                                    <label *ngIf="inputAddress.pristine" for="address">Object address</label>
                                    <input type="text" id="address" #inputAddress="ngModel" [(ngModel)]="address" [ngModelOptions]="{standalone: true}" (keyup)="onGetSearchAddress($event.target.value)" class="form-control">
                                </div>
                            </form>
                        </th>
                        <th scope="col">
                            <form #form="ngForm">
                                <div class="form-group">
                                    <label *ngIf="inputName.pristine" for="name">Driver name</label>
                                    <input type="text" id="name" #inputName="ngModel" [(ngModel)]="name" [ngModelOptions]="{standalone: true}" (keyup)="onGetSearchName($event.target.value)" class="form-control">
                                </div>
                            </form>
                        </th>
                        <th scope="col">
                            <form #form="ngForm">
                                <div class="form-group">
                                    <label *ngIf="inputCarNumber.pristine" for="carNumber">Car</label>
                                    <input type="text" id="carNumber" #inputCarNumber="ngModel" [(ngModel)]="carNumber" [ngModelOptions]="{standalone: true}" (keyup)="onGetSearchCarNumber($event.target.value)" class="form-control">
                                </div>
                            </form>
                        </th>
                        <th scope="col">
                            <form #form="ngForm">
                                <div class="form-group">
                                    <label *ngIf="inputStatus.pristine" for="status">In touch</label>
                                    <select class="form-control" id="status" name="status" #inputStatus="ngModel" [(ngModel)]="status" [ngModelOptions]="{standalone: true}" (change)="onGetSearchStatus($event.target.value)">
                                        <option value="">All</option>
                                        <option value="online">Online</option>
                                        <option value="offline">Offline</option>
                                    </select>
                                </div>
                            </form>
                        </th>
                        <th>
                            <form #form="ngForm">
                                <div class="form-group">
                                    <label *ngIf="inputDeliveryStatus.pristine" for="deliveryStatus">Status</label>
                                    <select
                                    class="form-control"
                                    id="deliveryStatus"
                                    name="deliveryStatus"
                                    #inputDeliveryStatus="ngModel"
                                    [(ngModel)]="deliveryStatus"
                                    [ngModelOptions]="{standalone: true}"
                                    (change)="onGetSearchDeliveryStatus($event.target.value)">
                                        <option value="">All</option>
                                        <option value="in-progress">In progress</option>
                                        <option value="done">Done</option>
                                    </select>
                                </div>
                            </form>
                        </th>
                        <th scope="col" class="label" sortable-column="date_loaded">Shippment</th>
                        <th scope="col" class="label" sortable-column="date_eta">Delivery</th>
                        <th scope="col" class="text-center">
                            <!-- <input
                                type="checkbox"
                                name="driver_item"
                                id="driver_item"
                                class="position-relative"
                                style="top: 2px;"
                                [checked]="isAllChecked()"> -->
                            <div class="form-group">
                                <div class="h-100 d-flex justify-content-center align-items-center label">On&nbsp;map</div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody *ngIf="filteredResult.length !== 0">
                    <tr
                        *ngFor="let driver of filteredResult | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; trackBy: trackByFn; let i = index"
                        (click)="onSelect(driver.shipment_id)"
                        [ngClass]="{'green': driver.tracking === 'online'}">
                        <td> {{ driver.request_id }} </td>
                        <td> {{ driver.shipment_id }} </td>
                        <td> {{ driver.plant_name }} </td>
                        <td> {{ driver.client_name }} </td>
                        <td> 
                           <!-- <div class="btn-wrapper">
                                <div>{{ driver.address}}</div>
                                <button
                                    *ngIf="!driver.checked_plant" 
                                    class="btn btn-success"
                                    (click)="addSelectedAddress(driver)">&#43;</button>
                                <button
                                    *ngIf="driver.checked_plant" 
                                    class="btn btn-danger"
                                    (click)="removeSelectedAddress(driver)">&times;</button>
                           </div> -->
                           <label class="driver-address">
                                <input type="checkbox"
                                    name="{{driver.address}}"
                                    value="{{driver.address}}"
                                    (change)="checkAddress(driver)"
                                    [checked]="driver.checked_plant"/>
                                {{driver.address}}
                            </label>
                        </td>
                        <td> {{ driver.driver_name }} </td>
                        <td> {{ driver.vehicle_info }} </td>
                        <td *ngIf="driver.tracking === 'online'"> Online </td>
                        <td *ngIf="driver.tracking === 'offline'"> Offline </td>
                        <td *ngIf="driver.delivery_status === 'in-progress'"> In&nbsp;progress </td>
                        <td *ngIf="driver.delivery_status === 'done'"> Done </td>
                        <td> {{ driver.date_loaded | slice:0:10 }} {{ driver.date_loaded | slice:11:16 }} </td>
                        <td> {{ driver.date_eta | slice:0:10 }} {{ driver.date_eta | slice:11:16 }} </td>
                        <td 
                            scope="row"
                            class="driver-map-wrap justify-content-center align-items-center">
                            <!-- <div class="btn-wrapper" *ngIf="driver.tracking === 'online'">
                                <button 
                                    *ngIf="!driver.checked"
                                    class="btn btn-success"
                                    (click)="addSelectedDriver(driver)">&#43;</button>
                                <button
                                    *ngIf="driver.checked"
                                    class="btn btn-danger"
                                    (click)="removeSelectedDriver(driver)">&times;</button>
                            </div> -->
                            <label class="driver-map" *ngIf="driver.tracking === 'online'">
                                <input type="checkbox"
                                    name="{{driver.name}}"
                                    value="{{driver.name}}"
                                    (change)="checkDriver(driver)"
                                    [checked]="driver.checked"/>
                            </label>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="filteredResult.length === 0">
                    <tr>
                        <td colspan="12" class="search-empty text-center pt-2 pb-2">
                            Search result is empty. Please, repeat the request later
                        </td>
                    </tr>
                </tbody>
            </table>            
            <div
                *ngIf="filteredResult.length >= 5"
                class="pagination-wrapper d-flex flex-wrap justify-content-between align-items-center pt-2 pb-2">
                <ngb-pagination
                    [collectionSize]="filteredResult.length"
                    [(page)]="page"
                    [pageSize]="pageSize"
                    [boundaryLinks]="true"
                    [maxSize]="maxSizeDesktop">
                </ngb-pagination>
                <select class="custom-select" style="width: auto" [(ngModel)]="pageSize">
                    <option [ngValue]="5">5 drivers on a page</option>
                    <option [ngValue]="10">10 drivers on a page</option>
                    <option [ngValue]="15">15 drivers on a page</option>
                </select>
            </div>
            <span class="search-quantity pt-2"> Found: {{ filteredResult.length }}</span>
            <span
                class="search-quantity pt-2"
                *ngIf="selectedDrivers.length > 0">
                    Drivers on map: {{ selectedDrivers.length }}</span>
            <span
                class="search-quantity pt-2"
                *ngIf="selectedAddress.length > 0">
                    Objects on map: {{ selectedAddress.length }}</span>
            <div class="on-map">
                <button
                    class="btn btn-dark"
                    (click)="checkAllAddresses()">All objects on map</button>
                <button
                    class="btn btn-debug"
                    (click)="unCheckAllAddresses()">Clear objects on map</button>
                <button
                    class="btn btn-dark"
                    (click)="checkAllDrivers()">All drivers on map</button>
                <button
                    class="btn btn-debug"
                    (click)="unCheckAllDrivers()">Clear drivers on map</button>
            </div>
        </div>
    </div>
</div>
<!-- Mobile View -->
<div *ngIf="!driversDesktop">
    <div *ngIf="data | tableFilter : searchName:searchPhone:searchCarNumber:searchCarrier:searchOrderNumber:searchRequestNumber:searchStatus:searchPlantName:searchClientName:searchAddress:searchDeliveryStatus as filteredResult">
        <div *ngIf="isLoading" class="spinner d-flex justify-content-center align-items-center">
            <app-spinner></app-spinner>
        </div>
        <div
            *ngIf="filteredResult.length !== 0"
            class="drivers-list-wrap">
            <div
                *ngIf="!isLoading">
                <div scope="col">
                    <form #form="ngForm">
                        <div class="form-group mb-3">
                            <label *ngIf="inputRequestNumber.pristine" for="requestNumber">Request ID</label>
                            <input type="text" id="requestNumber" #inputRequestNumber="ngModel" [(ngModel)]="requestNumber" [ngModelOptions]="{standalone: true}" (keyup)="onGetSearchRequestNumber($event.target.value)" class="form-control">
                        </div>
                    </form>
                </div>
                <div>
                    <form #form="ngForm">
                        <div class="form-group mb-3">
                            <label *ngIf="inputOrderNumber.pristine" for="orderNumber">Document ID</label>
                            <input type="text" id="orderNumber" #inputOrderNumber="ngModel" [(ngModel)]="orderNumber" [ngModelOptions]="{standalone: true}" (keyup)="onGetSearchOrderNumber($event.target.value)" class="form-control">
                        </div>
                    </form>
                </div>
                <div>
                    <form #form="ngForm">
                        <div class="form-group mb-3">
                            <label *ngIf="inputPlantName.pristine" for="plantName">Plant</label>
                            <select class="form-control" id="plantName" name="plantName" #inputPlantName="ngModel" [(ngModel)]="plantName" [ngModelOptions]="{standalone: true}" (change)="onGetSearchPlantName($event.target.value)">
                                <option value="">All</option>
                                <option value="Irpin">Plant&nbsp;Irpin</option>
                                <option value="Obolon">Plant&nbsp;Obolon</option>
                                <option value="Vidradnyi">Plant&nbsp;Vidradnyi</option>
                                <option value="Darnytsa">Plant&nbsp;Darnytsa</option>
                                <option value="Stolychnyi">Plant&nbsp;Stolychnyi</option>
                            </select>
                        </div>
                    </form>
                </div>
                <div>
                    <form #form="ngForm">
                        <div class="form-group mb-3">
                            <label *ngIf="inputClientName.pristine" for="clientName">Client</label>
                            <input type="text" id="clientName" #inputClientName="ngModel" [(ngModel)]="clientName" [ngModelOptions]="{standalone: true}" (keyup)="onGetSearchClientName($event.target.value)" class="form-control">
                        </div>
                    </form>
                </div>
                <div>
                    <form #form="ngForm">
                        <div class="form-group mb-3">
                            <label *ngIf="inputAddress.pristine" for="address">Object address</label>
                            <input type="text" id="address" #inputAddress="ngModel" [(ngModel)]="address" [ngModelOptions]="{standalone: true}" (keyup)="onGetSearchAddress($event.target.value)" class="form-control">
                        </div>
                    </form>
                </div>
                <div>
                    <form #form="ngForm">
                        <div class="form-group mb-3">
                            <label *ngIf="inputName.pristine" for="name">Driver name</label>
                            <input type="text" id="name" #inputName="ngModel" [(ngModel)]="name" [ngModelOptions]="{standalone: true}" (keyup)="onGetSearchName($event.target.value)" class="form-control">
                        </div>
                    </form>
                </div>
                <div>
                    <form #form="ngForm">
                        <div class="form-group mb-3">
                            <label *ngIf="inputCarNumber.pristine" for="carNumber">Car</label>
                            <input type="text" id="carNumber" #inputCarNumber="ngModel" [(ngModel)]="carNumber" [ngModelOptions]="{standalone: true}" (keyup)="onGetSearchCarNumber($event.target.value)" class="form-control">
                        </div>
                    </form>
                </div>
                <div>
                    <form #form="ngForm">
                        <div class="form-group mb-3">
                            <label *ngIf="inputStatus.pristine" for="status">Availability</label>
                            <select class="form-control" id="status" name="status" #inputStatus="ngModel" [(ngModel)]="status" [ngModelOptions]="{standalone: true}" (change)="onGetSearchStatus($event.target.value)">
                                <option value="">All</option>
                                <option value="online">Online</option>
                                <option value="offline">Offline</option>
                            </select>
                        </div>
                    </form>
                </div>
                <div>
                    <form #form="ngForm">
                        <div class="form-group mb-3">
                            <label *ngIf="inputDeliveryStatus.pristine" for="deliveryStatus">Status</label>
                            <select
                            class="form-control"
                            id="deliveryStatus"
                            name="deliveryStatus"
                            #inputDeliveryStatus="ngModel"
                            [(ngModel)]="deliveryStatus"
                            [ngModelOptions]="{standalone: true}"
                            (change)="onGetSearchDeliveryStatus($event.target.value)">
                                <option value="">All</option>
                                <option value="in-progress">In progress</option>
                                <option value="done">Done</option>
                            </select>
                        </div>
                    </form>
                </div>
            </div>
            <div
                *ngFor="let driver of filteredResult | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; trackBy: trackByFn; let i = index"
                (click)="onSelect(driver.shipment_id)"
                [ngClass]="{'green': driver.tracking === 'online'}"
                class="driver-card">
                <div>Delivery: {{ driver.request_id }} </div>
                <div>Shipment: {{ driver.shipment_id }} </div>
                <div>Plant: {{ driver.plant_name}} </div>
                <div>Client: {{ driver.client_name}} </div>
                <div>Client&#39;address {{ driver.address}}</div>
                <div class="btn-wrapper d-flex justify-content-between align-items-center">
                    <label>
                        <input type="checkbox"
                            name="{{driver.address}}"
                            value="{{driver.address}}"
                            (change)="checkAddress(driver)"
                            [checked]="driver.checked_plant"/>
                        {{driver.address}}
                    </label>
                </div>
                <div>Driver&#39;name: {{ driver.driver_name }} </div>
                <div>Car: {{ driver.vehicle_info }} </div>
                <div *ngIf="driver.tracking === 'online'">Driver: Online </div>
                <div *ngIf="driver.tracking === 'offline'">Driver: Onffline </div>
                <div *ngIf="driver.delivery_status === 'in-progress'">Status: In progress </div>
                <div *ngIf="driver.delivery_status === 'done'">Status: Done </div>
                <div>Shipment: {{ driver.date_loaded }} </div>
                <div>Delivery: {{ driver.date_eta }} </div>
                <div class="btn-wrapper d-flex justify-content-between align-items-center" *ngIf="driver.tracking === 'online'">
                    <p>Show driver on map</p>
                    <label *ngIf="driver.tracking === 'online'">
                        <input type="checkbox"
                            name="{{driver.name}}"
                            value="{{driver.name}}"
                            (change)="checkDriver(driver)"
                            [checked]="driver.checked"/>
                    </label>
                </div>
            </div>
            <div class="search-quantity pt-2 mb-3"> Found: {{ filteredResult.length }}</div>
            <div
                *ngIf="filteredResult.length >= 5"
                class="pagination-wrapper d-flex flex-wrap flex-column justify-content-between align-items-center pt-2 pb-2">
                <ngb-pagination
                    [collectionSize]="filteredResult.length"
                    [(page)]="page"
                    [pageSize]="pageSize"
                    [boundaryLinks]="true"
                    [maxSize]="maxSizeMobile"
                    class="mb-3">
                </ngb-pagination>
                <select class="custom-select" style="width: auto" [(ngModel)]="pageSize">
                    <option [ngValue]="5">5 drivers on a page</option>
                    <option [ngValue]="10">10 drivers on a page</option>
                    <option [ngValue]="15">15 drivers on a page</option>
                </select>
            </div>
            <div
                class="search-quantity pt-2 mb-3"
                *ngIf="selectedDrivers.length > 0">
                    On map: {{ selectedDrivers.length }}</div>
            <div class="on-map">
                <button
                    class="btn btn-dark"
                    (click)="checkAllDrivers()">All drivers on map</button>
                <button
                    class="btn btn-debug"
                    (click)="unCheckAllDrivers()">Clear drivers on map</button>
                <button
                    class="btn btn-dark"
                    (click)="checkAllAddresses()">All objects on map</button>
                <button
                    class="btn btn-debug"
                    (click)="unCheckAllAddresses()">Cler objects on map</button>
            </div>
        </div>
        <div class="search-empty text-center pt-2 pb-2" *ngIf="filteredResult.length === 0">
            Search result is empty. Please, repeat the request later
        </div>
    </div>
</div>
<div class="alert alert-danger text-center" *ngIf="errorMessage">
    <h1>An Error Occurred!</h1>
    <p>{{ error }}</p>
</div>
